module.exports = __webpack_public_path__ + "static/media/sergii-gulenok-61955-unsplash-sm.4cf30bd6.jpg";